<!--
 * @Descripttion:个人中心导航组件 
 * @Author: congz
 * @Date: 2020-07-03 09:40:21
 * @LastEditors: congz
 * @LastEditTime: 2020-08-09 13:02:14
--> 

<template>
  <div class="centerMenu" id="centerMenu">
    <el-col :span="4">
      <div class="menu">
        <div class="menu-content">
          <div class="menu-part">
            <p class="submenu">Personal Center</p>
            <ul class="menu-ul">
              <li>
                <router-link to="/center" class="menu-a">Personal Center</router-link>
              </li>
              <li>
                <router-link to="/favorite" class="menu-a">My Collection</router-link>
              </li>
              <li>
                <router-link to="/order" class="menu-a">My Order</router-link>
              </li>
              <li>
                <router-link to="/cart" class="menu-a">Shopping Cart</router-link>
              </li>
            </ul>
            <p class="submenu">Account Management</p>
            <ul class="menu-ul">
              <li>
                <router-link to="/user/details" class="menu-a">Information</router-link>
              </li>
              <li>
                <router-link to="/user/pass" class="menu-a">Password</router-link>
              </li>
              <li>
                <router-link to="/user/address" class="menu-a">Receiving Address</router-link>
              </li>
            </ul>
            <p class="submenu">About</p>
            <ul class="menu-ul">
              <li>
                <router-link to="/about" class="menu-a">Home</router-link>
              </li>
            </ul>
          </div>

          <div class="extra"></div>
        </div>
      </div>
    </el-col>
  </div>
</template>
<script>
export default {
  name: 'CenterMenu',
  data() {
    return {}
  },
  methods: {}
}
</script>
<style scoped>
.menu {
  background-color: #ffffff;
}
.menu-content {
  width: 120px;
  margin: 0 auto;
}
.submenu {
  padding-top: 30px;
  padding-bottom: 20px;
}
.menu-ul {
  line-height: 30px;
}
.menu-ul .menu-a {
  font-size: 15px;
  color: #064E3B;
}
.menu-ul .menu-a:hover {
  color: #10B981;
}
.extra {
  height: 40px;
}
/* 手机端适配 */
@media (max-width: 900px) {
  .menu-content {
    width: 100%;
    padding: 0 12px;
    box-sizing: border-box;
  }
  .submenu {
    padding-top: 16px;
    padding-bottom: 12px;
  }
  .menu-ul {
    line-height: 28px;
  }
  .extra {
    height: 16px;
  }
}
</style>
